import { defineMessages } from '../intl/defineMessages';

export const messages = defineMessages('helpers.dateTime.formatDateTime', {
    durationDaysFragment: '{days, plural, one {# day} other {# days}}',
    durationHoursFragment: '{hours, plural, one {# hour} other {# hours}}',
    durationMinutesFragment: '{minutes, plural, one {# minute} other {# minutes}}',
    durationSecondsFragment: '{seconds, plural, one {# second} other {# seconds}}',
    lessThanSecond: '<1 second',
});
